module.exports = __webpack_public_path__ + "img/logo.0216a99b.png";